var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { StoryModel } from './models/story.model';
import { plainToClass, classToClass } from 'class-transformer';
import { map, flatMap, catchError } from 'rxjs/operators';
import { StoryChunkLoadModel, StoryLoadConfigModel } from './state/story.state.model';
import { ChapterService } from './chapter.service';
import { StoryTranslationModel } from './models/story-translation.model';
import { StoryType } from './models/story-type.enum';
import { flatten } from 'lodash';
import { StoryLoadTypeEnum } from './models/story-load-type.enum';
import { EngineService } from '../engine/engine.service';
import { makeAsync } from '../shared/make-async';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../engine/engine.service";
import * as i3 from "./chapter.service";
// #TODO: [EM] Relocate all calls to Human engine to engineService.
// #TODO: [EM] Replace loading API to use ChapterModel objects (data) rather than humanChapter objects (engine state)
/**
 * These are broken up for progressive loading
 */
var globalTypes = ['reflections', 'lights']; // Not bound to objects
var staticTypes = ['material', 'geometry', 'transform']; // Needed for render
var dynamicTypes = ['tweens', 'morph']; // Needed to animate
var StoryService = /** @class */ (function () {
    function StoryService(http, engineService, chapterService) {
        this.http = http;
        this.engineService = engineService;
        this.chapterService = chapterService;
    }
    // get the object ids to be shown in the specified human chapter
    StoryService.prototype.getShownObjectsFromChapter = function (humanChapter) {
        var synchronziation = humanChapter.synchronization;
        var objectIds = [];
        Object.entries(synchronziation).forEach(function (_a) {
            var _b = __read(_a, 2), objectId = _b[0], sync = _b[1];
            if (sync.shown) {
                objectIds.push(objectId);
            }
        });
        return objectIds;
    };
    // create global/static/dynamic asset load chunks for the target chapter
    StoryService.prototype.getTargetChapterLoadChunks = function (storyId, humanChapter, config) {
        var globaltargetChunk = new StoryChunkLoadModel();
        var statictargetChunk = new StoryChunkLoadModel();
        var dynamictargetChunk = new StoryChunkLoadModel();
        globaltargetChunk.storyId = statictargetChunk.storyId = dynamictargetChunk.storyId = storyId;
        globaltargetChunk.chapterId = statictargetChunk.chapterId = dynamictargetChunk.chapterId = humanChapter.id;
        // global assets of target chapter
        // only load globalTargetChunks if we are doing a fresh load, not a module import
        // but what happens if theres an asset that needs to be loaded that wasn't loaded by the first chapter?
        // only create globalTargetChunk if the 
        // I don't want to exclude globalTargetChunk.  I only want to set it as inactive.
        // why is it currently set to active?  Because its the target chapter. (the glitchyness is most likely a bug)
        // should this function know about the mode of operation?  It already has a StoryLoadConfigModel param
        // would this work If i took out brain_v02 root?  
        // activating global assets causes the glitch back to chapter 1..
        // so when do I need to activate globalTargetChunk?
        // when we're loading from a fresh start
        // if it's off for subsequent loads, we might not activate assets that didn't exist 
        // maybe order matters? -> no
        // What is it about global target chunks??
        globaltargetChunk.objects = Human.scene.rootObjects.map(function (humanObject) { return humanObject.objectId; });
        globaltargetChunk.assetTypes = globalTypes;
        globaltargetChunk.activate = true;
        globaltargetChunk.activationConfig = config.targetChapterConfig.global;
        globaltargetChunk.readyState = {};
        globaltargetChunk.time = 0; // #TODO: [EM] - query the true global time
        // static assets of target chapter
        statictargetChunk.objects = this.getShownObjectsFromChapter(humanChapter);
        statictargetChunk.assetTypes = staticTypes;
        statictargetChunk.activate = true;
        statictargetChunk.activationConfig = config.targetChapterConfig.static;
        statictargetChunk.readyState = { model: true };
        statictargetChunk.time = 0;
        // dynamic assets of target chapter
        dynamictargetChunk.objects = this.getShownObjectsFromChapter(humanChapter);
        dynamictargetChunk.assetTypes = dynamicTypes;
        dynamictargetChunk.activate = true;
        dynamictargetChunk.activationConfig = config.targetChapterConfig.dynamic;
        dynamictargetChunk.readyState = { animation: true };
        dynamictargetChunk.time = 0;
        return [globaltargetChunk, statictargetChunk, dynamictargetChunk];
    };
    // chunk.activate needs to be set to false for either
    // 
    // create content load chunks from the chapter
    StoryService.prototype.getChapterLoadChunks = function (storyId, humanChapter, config) {
        var chunks = [];
        if (humanChapter.id === config.targetChapterId) {
            chunks = this.getTargetChapterLoadChunks(storyId, humanChapter, config);
        }
        else {
            var chapterObjets = this.getShownObjectsFromChapter(humanChapter);
            var _chunk = new StoryChunkLoadModel();
            _chunk.activate = false;
            _chunk.chapterId = humanChapter.id;
            _chunk.objects = chapterObjets;
            _chunk.storyId = storyId;
            if (config.chapterAssetBundle) {
                // queue up static/dynamic assets for joint loading
                _chunk.assetTypes = __spread(staticTypes, dynamicTypes, globalTypes);
                _chunk.readyState = { model: true, animation: true };
                chunks.push(_chunk);
            }
            else {
                // separate chunks for static and dynamic assets
                chunks.splice(0, 0, _chunk, classToClass(_chunk));
                chunks[0].assetTypes = staticTypes;
                chunks[0].readyState = { model: true };
                chunks[1].assetTypes = dynamicTypes;
                chunks[1].readyState = { animation: true };
            }
        }
        return chunks;
    };
    // create content load chunk for the rest of the scene graph
    StoryService.prototype.getSceneGraphLoadChunk = function (storyId, roots, config) {
        var chunk = new StoryChunkLoadModel();
        chunk.activate = false;
        chunk.chapterId = null;
        chunk.objects = roots.map(function (root) { return root.objectId; });
        chunk.storyId = storyId;
        chunk.assetTypes = __spread(staticTypes);
        chunk.readyState = { model: true, animation: false };
        return chunk;
    };
    // create load chunks for all at once loading
    StoryService.prototype.getAllAtOnceLoadChunks = function (storyId, config) {
        var chunk = new StoryChunkLoadModel();
        chunk.activate = true;
        chunk.chapterId = Human.timeline.rootTimelines[storyId]._chapters[0].id;
        chunk.objects = Human.scene.rootObjects.map(function (root) { return root.objectId; });
        chunk.storyId = storyId;
        chunk.assetTypes = __spread(globalTypes, staticTypes, dynamicTypes);
        chunk.readyState = { model: true, animation: true };
        return [chunk];
    };
    // create load chunks for progressive loading
    StoryService.prototype.getProgressiveLoadChunks = function (storyId, config) {
        var _this = this;
        var chunks = [];
        // create chunks for chapters according to story load configuration
        Human.timeline.rootTimelines[storyId]._chapters.forEach(function (humanChapter) {
            var _chapterChunks = _this.getChapterLoadChunks(storyId, humanChapter, config);
            if (humanChapter.id === config.targetChapterId) {
                // target chapter chunks go first
                chunks = __spread(_chapterChunks, chunks);
            }
            else {
                // add non-target chunks in order
                chunks = __spread(chunks, _chapterChunks);
            }
        });
        // resort chunks based on config
        if (config.sortBy === 'readyState') {
            chunks.sort(this.compareReadyState);
        }
        // ensure that this is the last chunk
        chunks.push(this.getSceneGraphLoadChunk(storyId, Human.scene.rootObjects, config));
        return chunks;
    };
    // create load chunks for on-demand loading
    StoryService.prototype.getOnDemandLoadChunks = function (storyId, config) {
        // if (Human.timeline.rootTimelines[storyId]._chapters.length === 2) {
        //   return mockChunks;
        // }
        var _this = this;
        var chunks = [];
        // create chunks for chapters according to story load configuration
        Human.timeline.rootTimelines[storyId]._chapters.forEach(function (humanChapter) {
            var _chapterChunks = _this.getChapterLoadChunks(storyId, humanChapter, config);
            if (humanChapter.id === config.targetChapterId) {
                // target chapter chunks go first
                chunks = __spread(_chapterChunks, chunks);
            }
            else {
                // add non-target chunks in order
                chunks = __spread(chunks, _chapterChunks);
            }
        });
        // resort chunks based on config
        if (config.sortBy === 'readyState') {
            chunks.sort(this.compareReadyState);
        }
        return chunks;
    };
    StoryService.prototype.compareReadyState = function (chunk1, chunk2) {
        // 0 - readyState false, 1 - at least model readyState, 2  - animation only ready state, 3 - ready state undefined
        var scoreA = chunk1.readyState ? (chunk1.readyState.model ? 1 : (chunk1.readyState.animation ? 2 : 0)) : 3;
        var scoreB = chunk2.readyState ? (chunk2.readyState.model ? 1 : (chunk2.readyState.animation ? 2 : 0)) : 3;
        if (scoreA < scoreB) {
            return -1;
        }
        else if (scoreA === scoreB) {
            // chapter tie breaker
            var chapter1 = Human.timeline.rootTimelines[chunk1.storyId]._chapters.findIndex(function (chapter) { return chapter.id === chunk1.chapterId; });
            var chapter2 = Human.timeline.rootTimelines[chunk2.storyId]._chapters.findIndex(function (chapter) { return chapter.id === chunk2.chapterId; });
            return (chapter1 < chapter2) ? -1 : ((chapter1 === chapter2) ? 0 : 1);
        }
        else {
            return 1;
        }
    };
    // get the index of the chapter in the story
    StoryService.prototype.getChapterIndex = function (storyId, chapterId) {
        if (Human.timeline.rootTimelines[storyId]) {
            var root = Human.timeline.rootTimelines[storyId];
            return root._chapters.findIndex(function (chapter) { return chapter.id === chapterId; });
        }
        else {
            return -1;
        }
    };
    // entry point to get either a module or bookmark
    StoryService.prototype.getStory = function (id, type, lang) {
        /**
         * type: string => 'module' or 'bookmark'
         * id: string => id of content
         */
        var _this = this;
        if (lang === void 0) { lang = 'en'; }
        // get content
        var story$ = type === 'bookmark' ? this.getBookmark(id) : this.getContent(id);
        // default English
        if (lang === 'en') {
            return story$;
        }
        else {
            var story_1;
            // transform content into target language
            return story$
                .pipe(flatMap(function (_story) {
                story_1 = _story;
                return _this.getStoryTranslation(id, type, lang);
            }))
                .pipe(map(function (translation) { return _this.translateStory(story_1, translation); }), catchError(function () { return story$; }));
        }
    };
    // get a biodigital module -> normalize chapter data
    StoryService.prototype.getContent = function (path) {
        return this.http.get("/content/modules/" + path + ".json")
            .pipe(map(function (result) {
            var story = plainToClass(StoryModel, result);
            return story;
        }));
    };
    // get a biodigital bookmark -> normalize chapter data
    StoryService.prototype.getBookmark = function (id) {
        return this.http.get("/search/bookmarks/data", { params: { be: id } })
            .pipe(map(function (result) {
            var story = plainToClass(StoryModel, result.bookmark);
            return story;
        }));
    };
    // create configuration for story loading
    StoryService.prototype.getLoadConfig = function (storyId, targetChapterIdx) {
        if (targetChapterIdx === void 0) { targetChapterIdx = 0; }
        var config = new StoryLoadConfigModel();
        config.chapterAssetBundle = true;
        config.targetChapterId = Human.timeline.rootTimelines[storyId]._chapters[targetChapterIdx].id;
        config.targetChapterConfig = {
            global: { clipping: true, graph: true, camera: true, properties: true, transparencyMode: true, postprocess: true },
            static: { labels: true },
            dynamic: { timeline: true, particles: true }
        };
        config.sortBy = 'readyState';
        return config;
    };
    // Create the Human module
    // #NOTE: [EM] This cannot safely be assumed to be synchronous. Wrap in an observable.
    // This is the entrypoint into the engine
    // when a new module arrives, it needs to be added to the existing story.
    StoryService.prototype.buildStory = function (storyId, story, activate) {
        Human.modules.moduleData[storyId] = story; // Place the JSON that into Human modules for local reference
        var moduleData = __assign({}, story);
        moduleData.moduleId = storyId; // needed by engine
        return new Observable(function (observer) {
            Human.modules.create(storyId, moduleData, function () {
                if (activate) {
                    Human.modules.activate(storyId, 0, {}, function () { });
                }
                observer.next(true);
                observer.complete();
            });
        });
    };
    StoryService.prototype.getStoryChapters = function (storyId, storyType) {
        var _this = this;
        var humanModuleData = Human.modules.moduleData[storyId];
        return Human.timeline.rootTimelines[storyId]._chapters.map(function (humanChapter, idx) {
            return _this.chapterService.fromHumanChapter(humanModuleData, storyType, humanChapter, idx);
        });
    };
    // create list of load chunks for loading story content into engine
    StoryService.prototype.getStoryLoadChunks = function (storyId, config, loadType) {
        var chunks = [];
        switch (loadType) {
            case StoryLoadTypeEnum.AllAtOnce:
                chunks = this.getAllAtOnceLoadChunks(storyId, config);
                break;
            case StoryLoadTypeEnum.Progressive:
                chunks = this.getProgressiveLoadChunks(storyId, config);
                break;
            case StoryLoadTypeEnum.OnDemand:
                chunks = this.getOnDemandLoadChunks(storyId, config);
                break;
            default:
                chunks = this.getProgressiveLoadChunks(storyId, config);
                break;
        }
        // ensure that this is the last chunk
        // chunks.push(this.getSceneGraphLoadChunk(storyId, Human.scene.rootObjects, config));
        return chunks;
    };
    // load story chunk into engine according to chunk configuration
    StoryService.prototype.loadStoryChunk = function (chunk, ok) {
        var objects = chunk.objects.map(function (id) { return Human.scene.objects[id]; }); // ids to objects
        // Preseed highlight property so that first user interactio with scene doesn't trigger recompile
        // #NOTE: [EM] This might result in unnecessary traversals. Perhaps a better place would be after module creation.
        chunk.objects.forEach(function (id) {
            Human.scene.getLeaves(id).forEach(function (leafId) {
                var leaf = Human.scene.objects[leafId];
                if (leaf instanceof Human.scene.Object) {
                    leaf.setHighlight(false);
                }
            });
        });
        if (!!chunk.storyId) {
            // story based loading
            Human.modules.load(chunk.storyId, objects, chunk.assetTypes, function () {
                ok();
            });
        }
        else {
            // object based loading
            this.engineService.loadGraphObject(chunk.objects[0]).subscribe(function () {
                ok();
            });
        }
    };
    // #TODO: Support multiple module ids
    StoryService.prototype.unloadStory = function (id, purgeAssets) {
        var _this = this;
        if (purgeAssets === void 0) { purgeAssets = true; }
        var ids = id ? [id] : Object.keys(Human.modules.modules);
        var deletions$ = ids.map(function (_id) { return _this.hardDeleteStory(_id, purgeAssets); });
        return new Observable(function (observer) {
            if (deletions$.length) {
                forkJoin(deletions$).subscribe(function () {
                    observer.next(true);
                    observer.complete();
                });
            }
            else {
                observer.next(true);
                observer.complete();
            }
        });
    };
    // create a load chunk for loading a objects
    StoryService.prototype.createLoadObjectChunk = function (id) {
        var chunk = new StoryChunkLoadModel();
        chunk.assetTypes = __spread(staticTypes, dynamicTypes);
        chunk.objects = [id];
        return chunk;
    };
    StoryService.prototype.hardDeleteStory = function (id, purgeAssets) {
        if (purgeAssets === void 0) { purgeAssets = true; }
        var assetTypes = ['geometries', 'morphs', 'reflections', 'tweens', 'lights', 'materials', 'transforms'];
        var storyGraph = id in Human.modules.modules ? Human.modules.modules[id].sceneGraph : [];
        var storyRoots = storyGraph.map(function (object) { return Human.scene.objects[object.objectId]; }).filter(function (obj) { return !!obj; });
        var storyObjects = flatten(storyRoots.map(function (root) { return root.getLeafObjects(); }));
        var deactivate = makeAsync(Human.modules.deactivate, id, {});
        var unload = makeAsync(Human.modules.unload, id, storyObjects, assetTypes);
        var destroy = makeAsync(Human.modules.destroy, id);
        return new Observable(function (observer) {
            function endObserver() {
                observer.next();
                observer.complete();
            }
            // #TODO: [EM] Engine bug, never calls deactivate callback if target module is not currently active.
            var shouldDeactivate = Human.timeline.activeRoot && Human.timeline.activeRoot.id === id;
            (shouldDeactivate ? deactivate() : Promise.resolve({}))
                .then(function () { return (purgeAssets ? unload() : Promise.resolve({})); })
                .then(function () { return destroy(); })
                .then(function () { return endObserver(); });
        });
    };
    /**
     * Gets the translation data for the specified content.
     */
    StoryService.prototype.getStoryTranslation = function (id, type, lang) {
        // translation data endpoint
        var url = type === 'bookmark' ? "/search/bookmarks/tr/" + lang + "/" + id : "/tr/" + lang + "/" + id + ".json";
        return this.http.get(url)
            .pipe(map(function (result) {
            return plainToClass(StoryTranslationModel, result);
        }));
    };
    /**
     * Check the requested id to determine if requested content is a bookmark or story
     * @param id Bookmark or module id
     */
    StoryService.prototype.getStoryType = function (id) {
        return (id.indexOf('/') >= 0) ? StoryType.Module : StoryType.Bookmark;
    };
    /**
     * Translate the specified story based on the input translations.
     */
    StoryService.prototype.translateStory = function (story, translation) {
        var _this = this;
        var chapters = story.chapters || [];
        var sceneGraph = story.sceneGraph || [];
        var translatedObjects = translation.objects || {};
        var translatedChapters = translation.chapters || [];
        // Translate story title + description
        story.displayName = translation.displayName || story.displayName;
        story.description = translation.description || story.description;
        // Translate scene graph
        sceneGraph.forEach(function (graph) {
            var objects = graph.objects || [];
            objects.forEach(function (object) {
                _this.translateObject(object, translatedObjects);
            });
        });
        // Translate chapters
        chapters.forEach(function (chapter, chapterIndex) {
            var translatedChapter = translatedChapters[chapterIndex];
            if (translatedChapter) {
                _this.translateMetaInfo(chapter, translatedChapter);
                // Translate annotations
                var annotations = chapter.annotations || [];
                var translatedAnnotations_1 = translatedChapter.annotations || [];
                annotations.forEach(function (annotation, annotationIndex) {
                    var translatedAnnotation = translatedAnnotations_1[annotationIndex];
                    if (translatedAnnotation) {
                        _this.translateMetaInfo(annotation, translatedAnnotation);
                    }
                });
                // Translate hotspots
                var hotspots = chapter.hotspots || [];
                var translatedHotspots_1 = translatedChapter.hotspots || [];
                hotspots.forEach(function (hotspot, hotspotIndex) {
                    var translatedHotspot = translatedHotspots_1[hotspotIndex];
                    if (translatedHotspot) {
                        _this.translateMetaInfo(hotspot, translatedHotspot);
                    }
                });
            }
        });
        // #TODO[AC]: translate global hotspots
        return story;
    };
    StoryService.prototype.translateMetaInfo = function (state, metaInfo) {
        var title = metaInfo.title, description = metaInfo.description;
        // translate title
        if (state.hasOwnProperty('displayName')) {
            state.displayName = title;
        }
        if (state.hasOwnProperty('title')) {
            state.title = title;
        }
        // translate description
        if (state.hasOwnProperty('description')) {
            state.description = description;
        }
    };
    StoryService.prototype.translateObject = function (object, translatedObjects) {
        var _this = this;
        var objectId = object.objectId;
        var translatedDisplayName = translatedObjects[objectId];
        // Translate object
        if (translatedDisplayName) {
            object.displayName = translatedDisplayName;
        }
        // Translate children
        var childObjects = object.objects;
        if (childObjects) {
            childObjects.forEach(function (childObject) {
                _this.translateObject(childObject, translatedObjects);
            });
        }
    };
    // copy normalized labels to their respective chapters
    StoryService.prototype.storeLabelsInChapters = function (labels, chapters) {
        chapters.forEach(function (chapter) {
            chapter.labels = labels.filter(function (label) { return label.chapterId === chapter.id; });
        });
    };
    StoryService.ngInjectableDef = i0.defineInjectable({ factory: function StoryService_Factory() { return new StoryService(i0.inject(i1.HttpClient), i0.inject(i2.EngineService), i0.inject(i3.ChapterService)); }, token: StoryService, providedIn: "root" });
    return StoryService;
}());
export { StoryService };
